import React from 'react'

const Privacy = () => {
  return (
    <div className="subpage policy">
      <h2 className="policy-title">
        개인정보처리동의서
      </h2>

      <div className="policy-page">

        <div className="fulltext-menu">
          주식회사 마인드아이티(이하 '회사'라고 합니다)는 개인정보보호법 등 관련 법령상의 개인정보보호 규정을 준수하며 귀하의 개인정보보호에 최선을 다하고 있습니다. <br />
          회사는 개인정보보호법에 근거하여 다음과 같은 내용으로 개인정보를 수집 및 처리하고자 합니다. <br />
          <br />
          다음의 내용을 자세히 읽어보시고 모든 내용을 이해하신 후에 동의 여부를 결정해주시기 바랍니다.
        </div>

        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제1조(개인정보 수집 및 이용 목적)
          </p>
          <p className="padding-bottom">
            이용자가 제공한 모든 정보는 다음의 목적을 위해 활용하며, 목적 이외의 용도로는 사용되지 않습니다.
          </p>
          <div className="padding-left">
            <div>
              <div className="fulltext-subtitle">
                1&#41;서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
              </div>
              콘텐츠체공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송
            </div>
            <div>
              <div className="fulltext-subtitle">
                2&#41; 회원 관리
              </div>
              회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가사용방지, 가입의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달
            </div>
            <div>
              <div className="fulltext-subtitle">
                3&#41; 마케팅 및 광고에 활용
              </div>
              신규서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계
            </div>
            <div>
              <div className="fulltext-subtitle">
                4&#41; 공익을 위한 연구
              </div>
              사례연구 등 공익을 위한 연구에 사용될 수 있으며, 개인의 성명이나 나이 등 개인정보는 일체 사용되지 않습니다. 목적 이외의 용도로는 사용되지 않습니다.
            </div>
            <div>
              <div className="fulltext-subtitle">
                5&#41; 개인건강정보 확인 목적
              </div>
            </div>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제2조(개인정보 수집 및 이용 항목)
          </p>
          <p className="padding-bottom">
            회사는 개인정보 수집 목적을 위하여 다음과 같은 정보를 수집합니다.
          </p>
          <div className="padding-left">
            <div>
              <div className="fulltext-subtitle">
                1&#41; 성명, 주소, 전화번호, 이메일, 생년월일
              </div>
            </div>
            <div>
              <div className="fulltext-subtitle">
                2&#41; 서비스 문의, 서비스 예약 시 아래 항목을 수집합니다.
              </div>
              - 이름, 연락처, 이메일, 문의사항, 상담희망 날짜, 상담희망 시간, 요청사항
            </div>
            <div>
              <div className="fulltext-subtitle">
                3&#41; 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
              </div>
              - 웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키, 접속IP정보, 결제기록 <br />
              - 모바일 이용 시: 서비스 이용 기록, 접속 로그, 기기고유번호(디바이스 아이디 또는 IMEI)
            </div>
            <div>
              <div className="fulltext-subtitle">
                4&#41; 고객 상담 시 서비스 품질 향상을 위해 담당자 연결 후 통화내용이 녹음되어 아래와 같은 정보들을 수집합니다.
              </div>
              - 통화이력 및 녹음 파일
            </div>
            <div>
              <div className="fulltext-subtitle">
                5&#41; 민감정보 사항
              </div>
              검사 및 진단 결과 등 개인건강정보에 관한 자료
            </div>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제3조(개인정보 보유 및 이용 기간)
          </p>
          <p className="padding-bottom">
            1. 수집한 개인정보는 수집·이용 동의일로부터 개인정보 수집·이용 목적을 달성할 때까지 보관 및 이용합니다.
          </p>
          <p className="padding-bottom">
            2. 개인정보 보유기간의 경과, 처리목적의 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
          </p>
          <div className="padding-left">
            <div>
              <span className="fulltext-subtitle">
                표시/광고에 관한 기록 :
              </span>
              6개월 (전자상거래등에서의 소비자보호에 관한 법률)
            </div>
            <div>
              <span className="fulltext-subtitle">
                계약 또는 청약철회 등에 관한 기록 :
              </span>
              5년 (전자상거래등에서의 소비자보호에 관한 법률)
            </div>
            <div>
              <span className="fulltext-subtitle">
                대금결제 및 재화 등의 공급에 관한 기록 :
              </span>
              5년 (전자상거래등에서의 소비자보호에 관한 법률)
            </div>
            <div>
              <span className="fulltext-subtitle">
                소비자의 불만 또는 분쟁처리에 관한 기록 :
              </span>
              3년 (전자상거래등에서의 소비자보호에 관한 법률)
            </div>
            <div>
              <span className="fulltext-subtitle">
                신용정보의 수집/처리 및 이용 등에 관한 기록 :
              </span>
              3년 (전자상거래등에서의 소비자보호에 관한 법률)
            </div>
            <div>
              <span className="fulltext-subtitle">
                통신비밀보호법에 따른 통신사실확인자료 :
              </span>
              3개월
            </div>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제4조(동의 거부 관리)
          </p>
          <p className="padding-bottom">
            귀하는 본 안내에 따른 개인정보 수집·이용에 대하여 동의를 거부할 권리가 있습니다. 다만, 귀하가 개인정보 동의를 거부하시는 경우에 서비스 이용 중 일부제한의 불이익이 발생할 수 있음을 알려드립니다.
          </p>
          <p className="padding-bottom">
            본인은 위의 동의서 내용을 충분히 숙지하였으며,위와 같이 개인정보를 수집·이용하는데 동의합니다.
          </p>
          <p className="padding-bottom">
            개인정보 수집 및 이용에 동의함 □ 동의하지 않음 □
          </p>
          <p className="padding-bottom">
            본인은 위의 내용을 충분히 숙지하였으며, 위와 같이 개인정보를 제3자에게 제공하는데 동의합니다.
          </p>
          <p className="padding-bottom">
            개인정보 제3자 제공에 동의함 □ 동의하지 않음 □
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제5조(개인정보의 처리 위탁)
          </p>
          <p className="padding-bottom">
            회사가 취득한 개인정보는 정보통신망 이용촉진 및 정보보호 등에 관한 법률에 의하여 제3자에게 개인정보를 수집·보관·처리·이용·제공·관리·파기 등을 할 수 있도록 아래와 같이 개인정보처리 업무를 위탁합니다.
          </p>
          <div className="padding-left">
            <div className="padding-bottom">
              1. 개인정보를 위탁 받는 자 : 제휴 상담 전문가
            </div>
            <div className="padding-bottom">
              2. 개인정보 위탁 업무 내용 : 서비스 관련 상담
            </div>
          </div>
          <p className="padding-bottom">
            회사는 이용자들에게 전문적인 서비스를 제공하는 과정에서 심리상담/코칭/그룹 등의 상담 업무를 제휴된 전문가에게 위탁하고 있습니다.
          </p>
          <p className="padding-bottom">
            회사는 서비스 제공을 위하여 필요한 업무중 일부를 외부 업체에 위탁할 수 있으며, 위탁할 경우 위탁 받은 업체가 정보통신망법에 따라 개인정보를 안전하게 처리하도록 필요한 사항을 규정하고 관리/감독을 합니다.
          </p>
          <p className="padding-bottom">
            회사는 서비스 향상을 위하여 아래와 같이 개인정보를 위탁하고 있으며, 개인정보의 수탁자와 위탁업무의 범위는 아래와 같습니다.
          </p>
          <div className="padding-left">
            <div className="padding-bottom">
              1. (주)KG이니시스, 카드사 : 신용카드, 휴대폰, 가상계좌 등을 통한 결제처리 및 결제도용 방지
            </div>
            <div className="padding-bottom">
              2. 제휴 전문가 : 심리상담/코칭/그룹 등의 서비스 제공, 심리검사/코칭/그룹 내용 확인 및 해석 등의 서비스와 관련된 업무 중 일부
            </div>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제6조(개인정보 파기 절차 및 방법)
          </p>
          <p className="padding-bottom">
            ① 회사는 원칙적으로 이용자의 회원 탈퇴 시 특정 보호 기간을 거쳐 수집된 이용자 개인정보가 열람 또는 이용될 수 없도록 파기 처리합니다. 단, 이용자에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우, 또는 법령에서 일정 기간 정보 보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.
          </p>
          <p className="padding-bottom">
            ② 개인정보 파기의 절차 및 방법은 다음과 같습니다.
          </p>
          <div className="padding-left">
            <div className="padding-bottom">
              <span className="fulltext-subtitle">파기 절차 :</span>
              이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져 (종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니라면 다른 목적으로 이용되지 않습니다
            </div>
            <div className="padding-bottom">
              <span className="fulltext-subtitle">파기 방법 :</span>
              종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. 전자적 파일 형태로 저장된 개인정보는 기록을 복구할 수 없는 기술적인 방법을 사용하여 삭제합니다.
            </div>
          </div>
        </div>
        <div className="fulltext-item">
          <p>
            본인은 위의 내용을 충분히 숙지하였으며, 위와 같이 개인정보처리 업무를 위탁하는데 동의합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p>
            개인정보 처리업무 위탁에 동의함 □&nbsp;&nbsp; 동의하지 않음 □
          </p>
        </div>
        <div className="fulltext-item">
          <p>
            2024년 &nbsp;&nbsp;&nbsp;월 &nbsp;&nbsp;&nbsp;일
          </p>
        </div>
        <div className="fulltext-item">
          <p>
            성명 : 본인 (서명 또는 인)
          </p>
        </div>
      </div>

    </div>
  )
}

export default Privacy